import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import './DriverVehicleTable.css'
import Paper from "@mui/material/Paper";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";

import { RiDeleteBin6Line } from "react-icons/ri";
// import EditVehicleDrawer from "../EditVehicleDrawer/EditVehicleDrawer";
import { useState } from "react";
import { useEffect } from "react";
import { getAllVehicles } from "../../redux/AdminReducer";
import { useSelector } from "react-redux";
import { deleteVehicle } from "../../redux/AdminReducer";
import { getDriverBus } from "../../redux/DriverReducer";
export default function DriverVehicleTable() {
  const [deleteVeh, setDeleteVeh] = useState(0);

  const dispatch = useDispatch();
  const [alertIndex, setAlertIndex] = useState();

  // const vehicleData = useSelector(
  //   (state) => state?.AdminReducer?.allVehiclesData
  // );
  const vehicleData = useSelector(
    (state) => state?.DriverReducer?.getDriverBusData?.vehicle
  );

  // console.log("vehicleDataSingle", vehicleDataSingle);
  // const vehicleData=[
  //     {
  //         catagory:"Saloon",
  //         company:"Toyata",
  //         passenger:"3",
  //         luggage:"5",
  //         price:"200",
  //         availability:true

  //     },
  //     {
  //         catagory:"Saloon",
  //         company:"Toyata",
  //         passenger:"3",
  //         luggage:"5",
  //         price:"200",
  //         availability:true

  //     },
  //     {
  //         catagory:"Saloon",
  //         company:"Toyata",
  //         passenger:"3",
  //         luggage:"5",
  //         price:"200",
  //         availability:true

  //     },
  //     {
  //         catagory:"Saloon",
  //         company:"Toyata",
  //         passenger:"3",
  //         luggage:"5",
  //         price:"200",
  //         availability:false

  //     },
  //     {
  //         catagory:"Saloon",

  //         company:"Toyata",
  //         passenger:"3",
  //         luggage:"5",
  //         price:"200",
  //         availability:true

  //     },

  // ]

  const deleteIconClicked = (index) => {
    setAlertIndex(index);

    setDeleteVeh(1);
  };

  const noClickedAlert = () => {
    setDeleteVeh(2);
  };

  useEffect(() => {
    dispatch(getDriverBus());
  }, []);

  const yesDeleteClicked = async (data) => {
    let id = data._id;

    const response = await dispatch(deleteVehicle({ id, vehicleData }));

    console.log("responseDeletedVehicle", data);

    setDeleteVeh(2);
  };
  return (
    <div className="mainTopVehDriverTbl">
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Catagory</TableCell>
              <TableCell align="right">Company</TableCell>
              <TableCell align="right">Passenger</TableCell>
              <TableCell align="right">Luggage</TableCell>
              <TableCell align="right">Price</TableCell>
              <TableCell align="right">Availability</TableCell>
              {/* <TableCell align="right">Delete</TableCell>
              <TableCell align="right">Edit</TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            {vehicleData?.map((row, index) => (
              <TableRow
                key={row?.name}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  {row?.catagory}
                </TableCell>
                <TableCell align="right">{row?.company}</TableCell>
                <TableCell align="right">{row?.passenger}</TableCell>
                <TableCell align="right">{row?.luggage}</TableCell>
                <TableCell align="right">{row?.price}</TableCell>
                <TableCell align="right">
                  {row?.availability ? "Available" : "Not Available"}
                </TableCell>
                {/* <TableCell align="right">
                  <RiDeleteBin6Line
                    onClick={() => deleteIconClicked(index)}
                    className="deleteVehicleIcon"
                  />
                </TableCell> */}
                <TableCell align="right" className="editColDataVeh">
                  {/* <FiEdit2/> */}

                  {/* <EditVehicleDrawer data={row}/> */}
                </TableCell>

                {deleteVeh === 1 && alertIndex === index && (
                  <div className="mainDeleteCardVehicle">
                    <div className="confirmTxtAlertVehDlt">
                      {" "}
                      You want to delete Vehicle?
                    </div>
                    <div className="topConfirmBtnDeltVeh">
                      <div
                        className="noBtnAlertDltVeh"
                        onClick={noClickedAlert}
                      >
                        No
                      </div>
                      <div
                        className="yesBtnAlertDltVeh"
                        onClick={() => yesDeleteClicked(row)}
                      >
                        Yes
                      </div>
                    </div>
                  </div>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
